import { InlineRow, Row } from './AdRow';
import ImageAd from './ImageAd';
import StickyBanner from './StickyBanner';

const AuszugAtUrl = 'https://www.auszug.at?utm_source=wirtschaft&utm_medium=ads&utm_campaign=ws_display';

export default { ImageAd, StickyBanner,  InlineRow, Row, AuszugAtUrl };